































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import logger from "@/configs/logger";
import { sendEmail } from "@/lib/api";
import { collections } from "@/configs/firebase";
import { User } from "@/types";

@Component
export default class ComposeEmail extends Vue {
  @Prop({ required: true }) template!: any;
  @Prop() email!: string;
  @Prop() leadId!: string;
  @State("user") user!: User;

  valid = true;
  recipient = this.email || "";
  subject = "";
  body = "";

  emailRules = [
    (v: string) => !!v || "E-mail is required",
    (v: string) => /.+@.+\..+/.test(v) || "E-mail must be valid"
  ];

  bodyRules = [(v: string) => !!v || "Email body is required"];

  subjectRules = [(v: string) => !!v || "Email subject is required"];

  @Watch("template")
  onTemplateUpdate(val: any, prev: any) {
    this.setTemplate(val);
  }

  @Watch("email")
  onEmailUpdate(val: string, prev: string) {
    if (val !== prev) {
      this.recipient = val;
    }
  }

  mounted() {
    this.setTemplate(this.template);
    this.recipient = this.email || "";
  }

  setTemplate(template: any) {
    if (template) {
      this.body = template.body;
      this.subject = template.subject;
    } else {
      this.subject = "";
      this.body = "";
    }
  }

  async submit() {
    //@ts-ignore
    const isValid = this.$refs.form.validate();
    if (isValid) {
      try {
        const message: any = {
          recipient: this.recipient,
          subject: this.subject,
          body: `<a>${this.body}</a>`
        };
        const res = await sendEmail(message);
        window.console.log("resposne status:", res.status);
        this.$toasted.success("Email successfully sent").goAway(2000);

        await collections.logMessages.add({
          lead_id: this.leadId || null,
          message_type: "email",
          sent_by: this.user.email,
          ...message
        });
      } catch (err) {
        logger("error", "send email error:", err.response);
        this.$toasted
          .error("An error occured: failed to send email.")
          .goAway(2000);
      }
    }
  }
}
